<template>
    <div class="w-full max-w-30rem">
        <Button :label="buttons[lang_].watchVideo" 
            class="flex w-full align-items-center text-500 border-round-xl" severity="secondary" variant="text"
            @click="show_video('howToCreateTransfer')" icon="pi pi-play-circle" iconPos="right" />
    </div>
    <Dialog v-model:visible="showToCreateTransfer" :header="buttons[lang_].header" modal blockScroll
        :style="(screen_size=='xs' || screen_size=='sm' || screen_size=='md') ? { width: '100%', height: '100%' } : { width: '75vw' }" 
        :contentStyle="(screen_size=='xs' || screen_size=='sm' || screen_size=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screen_size=='xs') ? 'h-full' : ''"
        class="w-full px-1" style="max-width: 800px">
        <div v-if="isTgApp">
            <iframe width="100%" height="500" src="https://www.youtube.com/embed/6B7hKQL9d5c" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div v-else>
            <iframe v-if="(screen_size=='sm' || screen_size=='xs')" width="100%" height="500" src="https://www.youtube.com/embed/sMwYNxul8yQ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            <iframe v-else width="100%" height="315" src="https://www.youtube.com/embed/sMwYNxul8yQ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
    </Dialog>
</template>

<script>
import { useCookies } from "vue3-cookies"

export default {
    name: 'hintVideo',
    data() {
        return {
            showToCreateTransfer: false,
            buttons:  {
                ru:{
                    how2create: "Смотрите видео инструкцию – как сделать первый перевод 👇",
                    watchVideo: "Видео – как создать перевод",
                    header: 'Как сделать перевод'
                },
                en:{
                    how2create: "Watch the video instruction on how to make a transfer 👇",
                    watchVideo:  "Video - how to create a transfer",
                    header: 'How to make a transfer'
                }              
            },
            cookies: useCookies(),
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screen_size() { return this.$store.getters.StateScreenSize },
        hintToCreateTransfer(){ return this.$store.getters.StateHintToCreateTransfer },
        isTgApp: function () { return this.$store.getters.StateTgApp },
    },
    methods: {
        async show_video(name) {
            if(name=='howToCreateTransfer'){
                this.showToCreateTransfer = true
            }
        },
        async close_hint(name) {
            if(name=='howToCreateTransfer') {
                this.hintToCreateTransfer = false
                try{
                    await this.$store.dispatch('sawHowToCreateTr', true).then(() => {})
                } catch {}
                this.cookies.cookies.set("saw_video_howToCreateTransfer", true)
                localStorage.setItem('saw_video_howToCreateTransfer', true)
            }
        },
    }
}
</script>